import { render, staticRenderFns } from "./VoyageSonam.vue?vue&type=template&id=f7094d12&scoped=true"
import script from "./VoyageSonam.vue?vue&type=script&lang=js"
export * from "./VoyageSonam.vue?vue&type=script&lang=js"
import style0 from "./VoyageSonam.vue?vue&type=style&index=0&id=f7094d12&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7094d12",
  null
  
)

export default component.exports